import React, { useState } from "react";
import axios from "axios";
import Results from "./Results";
import Photos from "./Photos";
import "./Dictionary.css";

export default function Dictionary(props) {
    //state created to keep track of the word we want to search for
    //String
    let [keyword, setKeyword] = useState(props.defaultKeyword);
    //state created to keep track of the results for the word searched
    //Object
    let [results, setResults] = useState(null);
    //state created to keep track if a word was submitted or not
    let [loaded, setLoaded] = useState(false);
    //state created to keep track of the photos being created
    let [photos, setPhotos] = useState(null);

    function handleDictionResponse(response) {
        //every time we get a response from the dictionary API, store that in results
        setResults(response.data[0]);
    }

    function handlePexelsResponse(response) {
        //every time we get a response from the photos API, store that in photos
        setPhotos(response.data.photos);
    }

    function search() {
        //making the API call for the dictionary text data response
        // documentation: https://dictionaryapi.dev/
        let apiUrl = `https://api.dictionaryapi.dev/api/v2/entries/en_US/${keyword}`;
        axios.get(apiUrl).then(handleDictionResponse);

        //making the API call for the dictionary photos response
        let pexelsApiKey = 
            "563492ad6f917000010000019d51062f8ca74db78f6cdeaaab1c6dfd";
        let pexelsApiUrl = 
            `https://api.pexels.com/v1/search?query=${keyword}&per_page=9`;
        let headers = { Authorization: `Bearer ${pexelsApiKey}`};
        axios.get(pexelsApiUrl, {headers: headers }).then(handlePexelsResponse);
    }

    //on search submition, call the search function
    function handleSubmit(event) {
        event.preventDefault();
        search();
    }

    //when a word is being typed-in, hold that value in "keyword"
    function handleKeywordChange(event) {
        setKeyword(event.target.value);
    }

    function load() {
        //rerun the return bellow
        setLoaded(true);
        //search for the default keyword
        search();
    }

    //if a word was submitted
    if (loaded) {
        return (
            <div className="Dictionary">
                <section>
                    <h1>What are you looking for?</h1>
                    {/* on search submition, execute search function */}
                    <form onSubmit={handleSubmit}>
                        {/* when a word is being typed-in, execute handleKeywordChange function */}
                        <input 
                            type="search" 
                            onChange={handleKeywordChange}
                            defaultValue={props.defaultKeyword}
                            />
                    </form>
                    <div className="hint">
                        suggested words: sunset, wine, yoga, plant...
                    </div>
                </section>
                {/*component name     property name      property value */}
                {/* sending the results every time results are being updated, to the Results component*/}
                <Results results={results} />
                {/* sending the results every time photos are being updated, to the Photos component*/}
                <Photos photos={photos} />
            </div>
        );
    }
    //if no word was submitted, call load() and display "Loading"
    else {
        load();
        return "Loading";
    }
}